// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"199":"e13b194a","755":"69ad4137"}[chunkId] + ".chunk.css";
};